<template>
  <el-container
    class="two-row-element"
    :style="styleProps()"
  >
    <el-main class="two-row-data">
      <slot name="data" />
    </el-main>
    <el-footer class="two-row-title">
      <slot name="title" />
    </el-footer>
  </el-container>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private fontSize!: number
  @Prop({ required: false }) private dataColor!: string
  @Prop({ required: false }) private titleColor!: string
  private styleProps() {
    return {
      '--main-font-size': this.fontSize + 'px',
      '--data-color': this.dataColor ? this.dataColor : 'hsl(0, 0%, 30%)',
      '--title-color': this.titleColor ? this.titleColor : 'hsla(0, 0%, 30%, 0.7)'
    }
  }
}
</script>

<style lang="scss" scoped>
.two-row-element {
  display: flex;
  flex-grow: unset;
  margin-bottom: var(--main-font-size);
  .two-row-data {
    color: var(--data-color);
    font-weight: bold;
    font-size: var(--main-font-size);
    line-height: calc(var(--main-font-size) + 4px);
    margin: 0;
    padding: 0;
    border-top: 0px;
    border-bottom: 1px;
    border-style: solid;
    border-image: linear-gradient(
        to right,
        var(--title-color),
        hsla(0, 0%, 100%, 0)
      )
      100% 1;
  }
  .two-row-title {
    margin: 0;
    height: fit-content !important;
    padding: 2px 0 0 10px;
    font-size: calc(var(--main-font-size) - var(--main-font-size)/4);
    line-height: calc(var(--main-font-size) - var(--main-font-size)/4);
    height: calc(var(--main-font-size) + 4px);;
    color: var(--title-color);
  }
}
</style>
